import "../css/privacyPolicy.css";
import {
  FaShieldAlt,
  FaUserLock,
  FaCookieBite,
  FaCreditCard,
  FaEnvelope,
  FaLock,
} from "react-icons/fa";

function PrivacyPolicy() {
  return (
    <div className="privacy-page">

      {/* Hero */}

      <section className="privacy-hero">

        <div className="privacy-overlay">

          <h1>Privacy Policy</h1>

          <p>
            Your privacy matters to us. Learn how SIP LIQUORS collects,
            uses, and protects your personal information.
          </p>

        </div>

      </section>

      {/* Intro */}

      <section className="privacy-section">

        <div className="privacy-container">

          <h2>Our Commitment</h2>

          <p>
            At SIP LIQUORS, protecting your privacy is one of our top
            priorities. We only collect information necessary to process
            your orders, improve your shopping experience, and provide
            excellent customer support.
          </p>

        </div>

      </section>

      {/* Cards */}

      <section className="privacy-section gray">

        <div className="privacy-container">

          <div className="privacy-grid">

            <div className="privacy-card">
              <FaUserLock className="privacy-icon" />
              <h3>Information We Collect</h3>
              <p>
                Name, email address, phone number, shipping address,
                billing information, and order history.
              </p>
            </div>

            <div className="privacy-card">
              <FaCreditCard className="privacy-icon" />
              <h3>Secure Payments</h3>
              <p>
                Payments are securely processed using trusted payment
                providers. We never store your card details.
              </p>
            </div>

            <div className="privacy-card">
              <FaCookieBite className="privacy-icon" />
              <h3>Cookies</h3>
              <p>
                Cookies help us remember your preferences and improve
                your browsing experience.
              </p>
            </div>

            <div className="privacy-card">
              <FaEnvelope className="privacy-icon" />
              <h3>Marketing Emails</h3>
              <p>
                Promotional emails are sent only if you subscribe. You
                can unsubscribe at any time.
              </p>
            </div>

            <div className="privacy-card">
              <FaLock className="privacy-icon" />
              <h3>Data Protection</h3>
              <p>
                We use encryption and secure servers to protect your
                personal information.
              </p>
            </div>

            <div className="privacy-card">
              <FaShieldAlt className="privacy-icon" />
              <h3>Your Rights</h3>
              <p>
                You may request access, correction, or deletion of your
                personal information at any time.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* Policy */}

      <section className="privacy-section">

        <div className="privacy-container">

          <h2>How We Use Your Information</h2>

          <ul className="privacy-list">

            <li>✔ Process and deliver your orders.</li>

            <li>✔ Verify your identity and age when required.</li>

            <li>✔ Improve our products and services.</li>

            <li>✔ Respond to customer inquiries.</li>

            <li>✔ Prevent fraud and unauthorized activity.</li>

            <li>✔ Send important order updates.</li>

          </ul>

        </div>

      </section>

      {/* Footer */}

      <section className="privacy-bottom">

        <div className="privacy-container">

          <h2>Your Privacy Is Our Priority</h2>

          <p>
            We continuously improve our security practices to ensure
            your information remains safe and protected.
          </p>

        </div>

      </section>

    </div>
  );
}

export default PrivacyPolicy;